import React from 'react';
import { Users } from 'lucide-react';

/**
 * Pick people from your play history. Shared component — fork uses it now, and
 * direct invites will use the same one rather than growing a second.
 *
 * Everyone starts selected: the common case is the whole crowd regrouping, and
 * an empty list would mean ticking fourteen boxes to do the obvious thing.
 *
 * Ordered by games played together, never alphabetically. "Played 6 games with"
 * is recognisable at a glance; an alphabetical list has to be read line by line,
 * and it buries the people you know best where you are least likely to look.
 */
function PlayerPicker({ players, selectedIds, onToggle, emptyHint }) {
  if (!players || players.length === 0) {
    return (
      <div className="empty-state">
        <Users size={40} />
        <p>{emptyHint || "You haven't played with anyone yet."}</p>
      </div>
    );
  }

  return (
    <div className="player-picker">
      {players.map((p) => {
        const selected = selectedIds.includes(p.playerId);
        return (
          <label key={p.playerId} className={selected ? 'player-row selected' : 'player-row'}>
            <input
              type="checkbox"
              checked={selected}
              onChange={() => onToggle(p.playerId)}
              aria-label={p.displayName}
            />
            <span className="player-row-name">{p.displayName}</span>
            <span className="player-row-meta">
              {p.sharedGames === 1 ? '1 game together' : `${p.sharedGames} games together`}
            </span>
          </label>
        );
      })}
    </div>
  );
}

export default PlayerPicker;
